<template>
    <div id="wt-header-notifications">
      <router-link :to="{name: 'configurations'}"  class="btn btn-lg wt-btn">
        <i class="fa fa-cog"></i>
      </router-link>
      <router-link :to="{name: 'notifications'}"  class="btn btn-lg wt-btn">
        <i class="fas fa-bell wt-nofifications-button"></i>
      </router-link>
      <router-link :to="{name: 'messages'}"  class="btn btn-lg wt-btn">
        <i class="fas fa-envelope-open"></i>
      </router-link>
    </div>
</template>

<script>
  export default {
    name: 'wt-header-notifications',
    components: {  },
    props: {  },    
    computed: {  },
    data: function() {
        return {
        }
    },
    methods: {
      onClick() {
        this.$bvModal.msgBoxOk('User name: Fred Flintstone', {
          title: 'User Info',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0'
        })
      }
    }
  }
</script>